import { ICoreContext } from '@msdyn365-commerce/core';
/**
 * The currently supported translation keys
 */
export enum TranslationKey {
    MemberPriceMessage = 'memberPriceMessage'
}
/**
 * Returns the translation for the given key and locale
 * @param key
 * @param context
 * @returns string | null
 */
export function getTranslation(key: TranslationKey, context: ICoreContext): string | null {
    if (context.actionContext.requestContext.app.config.translations) {
        const translation = context.actionContext.requestContext.app.config.translations.find((translation: any) => {
            return translation.key === key && translation.locale.toLowerCase() === context.request.locale.toLowerCase();
        });
        return translation ? translation.value : null;
    }
    return null;
}
